<style lang='scss'>
</style>

<script>
import Layout from '@layouts/main'
import {AxiosHelper} from '@src/utils/utils';

export default {
	components: { Layout },
  data() {
    return {
			timeGap : 1,
			process : 1,
			subsFile : null,
		}
	},
	beforeCreate() {
	},
	created() {
	},
	mounted() {
	},
	methods : {
		processFile : function(evt) {
			this.subsFile = evt.target.files[0];
		},

		seeking() {
			var form = new FormData();
			form.append('time_gap', this.timeGap);
			form.append('process', this.process);
			form.append('subs_file', this.subsFile, this.subsFile.name);

			AxiosHelper.post(`/api/etc/subs/seeking`, form, {
				headers : {
					'Content-Type' : 'multipart/form-data'
				}
			}).then(data => {
				var blob = new Blob([data]);
				// 파일저장
				if (navigator.msSaveBlob) {
					return navigator.msSaveBlob(blob, this.subsFile.name);
				}
				else {
					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = this.subsFile.name;
					link.click();
				}
			})
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader title="자막 싱크 조절" />

		<C.Row>
			<C.Col md="7">
				<C.Card>
					<C.CardHeader class="bg-secondary text-white">
						자막의 싱크를 조절. 자막이 영상보다 빠를 경우 '느리게', 자막이 영상보다 느릴 경우 '빠르게' 선택
					</C.CardHeader>
					<C.CardBody>
						<div class="form-row align-items-center">
							<div class="col-auto">
								<C.TouchSpin 
									v-model="timeGap"
									data-step="0.5"
									data-decimals="1" 
									data-bts-postfix="초"
								/>
							</div>
							<div class="col-auto">
								<div class="radio radio-info form-check-inline">
									<input id="inlineRadio1" v-model="process" type="radio" value="-1"/>
									<label for="inlineRadio1">빠르게</label>
								</div>
								<div class="radio form-check-inline">
									<input id="inlineRadio2" v-model="process" type="radio" value="1"/>
									<label for="inlineRadio2">느리게</label>
								</div>
							</div>
						</div>
						<C.Row class="mt-2">
							<C.Col>
								<input type="file" accept=".smi,.srt" class="form-control" @change="processFile"/>
							</C.Col>
						</C.Row>
						<C.Row class="mt-2">
							<C.Col>
								<button class="btn btn-primary" @click="seeking">변환 시작</button>
							</C.Col>
						</C.Row>
					</C.CardBody>
				</C.Card>
			</C.Col>

		</C.Row>
  </Layout>
</template>